import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getDisclosureLevel4,
  saveBatchDisclosureLevel4,
} from '../../api/disclosureLevel4';
import type { DisclosureLevel4 } from '../../types/DisclosureLevel4';
import { t } from '../../i18n/t';

const columnDefs: ColDef<DisclosureLevel4>[] = [
  {
    field: 'parentCodeId',
    headerName: t('disclosureLevel4.columns.parentCodeId'),
    width: 140,
    cellDataType: 'text',
    // Add-only like codeId (Nitzan 30/08/2026): re-parenting a saved code is
    // delete + re-add, mirroring the natural-PK rule.
    editable: (params: EditableCallbackParams<DisclosureLevel4>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
  },
  {
    field: 'codeId',
    headerName: t('disclosureLevel4.columns.codeId'),
    width: 140,
    cellDataType: 'text',
    // String natural PK: editable on Add only, read-only after save. The
    // leading zero must display and round-trip as a string.
    editable: (params: EditableCallbackParams<DisclosureLevel4>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'codeName',
    headerName: t('disclosureLevel4.columns.codeName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<DisclosureLevel4> => ({
  parentCodeId: '',
  codeId: '',
  codeName: '',
});

export function DisclosureLevel4Page() {
  return (
    <LopCrudPage<DisclosureLevel4>
      resourceCode="disclosureLevel4"
      titleKey="disclosureLevel4.pageTitle"
      idField="codeId"
      getRows={getDisclosureLevel4}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchDisclosureLevel4(added, modified, deletedIds as string[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
